import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import { Button, ColorBlock, Icon, Text } from 'core/components';
export default class ShortcutButton extends Component {
  shouldComponentUpdate(props) {
    const {
      active,
      disabled
    } = this.props;
    return props.active !== active || props.disabled !== disabled;
  }
  render() {
    const {
      icon,
      count: _count,
      active,
      type,
      label: _label,
      disabled,
      numDevices,
      activeDevices,
      ...rest
    } = this.props;
    const numberOfDevices = (typeof activeDevices === 'number' ? activeDevices : activeDevices?.length) ?? numDevices;
    let shortcutIcon;
    if (type === 'site') {
      shortcutIcon = 'map-marker';
    } else if (type === 'label') {
      shortcutIcon = /*#__PURE__*/React.createElement(ColorBlock, {
        disabled: disabled,
        color: rest.color,
        style: {
          width: 14,
          height: 14,
          minHeight: 14,
          marginRight: 7
        }
      });
    } else {
      shortcutIcon = icon;
    }
    return /*#__PURE__*/React.createElement(Button, _extends({
      fill: true,
      textAlign: "left",
      minimal: true,
      active: active,
      mb: "1px",
      disabled: disabled
    }, rest, {
      icon: shortcutIcon,
      rightIcon: /*#__PURE__*/React.createElement(React.Fragment, null, !active && /*#__PURE__*/React.createElement(Text, {
        small: true,
        muted: true,
        style: {
          opacity: numberOfDevices === 0 ? 0.45 : 1
        }
      }, numberOfDevices), active && /*#__PURE__*/React.createElement(Icon, {
        icon: "small-tick",
        style: {
          marginRight: 0
        }
      }))
    }));
  }
}